import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountComponent } from '@app/client/account/account.component';
import { ACCOUNT_ROUTES } from '@app/client/account/account.routes';
import { LayoutModule } from '@app/client/account/layout/layout.module';
import { SharedModule } from '@app/shared/shared.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';

@NgModule({
  declarations: [
    AccountComponent,
  ],
  imports: [
    RouterModule.forChild(ACCOUNT_ROUTES),
    LayoutModule,
    CommonModule,
    SharedModule,
    SmashFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccountModule { }
